import { z } from 'zod';

// Matches UserIdentityValidator.MAX_EMPLOYEE_ID_LENGTH on the backend.
const MAX_EMPLOYEE_ID_LENGTH = 50;

// Trims before the length check to match the backend's trim-then-validate order.
export const optionalEmployeeIdSchema = z
  .string()
  .trim()
  .max(MAX_EMPLOYEE_ID_LENGTH)
  .optional();
